import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseDto } from '../../../shared/modules/base/dtos/base.dto';
import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { MapCoordinateDto } from '../../../shared/modules/shared/dtos/map-coordinate.dto';
import { TenantContactDto } from '../../contacts/dtos/tenant-contact.dto';
import { PolicyAssignDto } from '../../policies/dtos/policy-assign.dto';
import { TagListDto } from '../../tags/dtos/tag-list.dto';
import { LocationStatusEnum } from '../enums/location-status.enum';
import { LocationTypeEnum } from '../enums/location-type.enum';

/**
 * Location DTO for records
 */
@CaslSubject(AppSubjectEnum.LOCATION)
export class LocationRecordDto extends BaseDto {
  uuid!: string;
  code!: string;
  name!: string;
  status!: LocationStatusEnum;
  notes?: string | null;
  type!: LocationTypeEnum;
  contact!: TenantContactDto;
  areaId!: number;
  isPickUp?: boolean | null;
  isDropOff?: boolean | null;
  isPrivate?: boolean | null;
  gpsCoordinates!: MapCoordinateDto;
  tags?: TagListDto[] | null;
  policies?: PolicyAssignDto[] | null;
  files?: FileDto[] | null;
}
